import { call, put } from 'redux-saga/effects';
import { setUserDetails } from '../account/accountSlice';
import {
  requestGetAadhaarEsignCredentials,
  requestGetDigioImageVerifyCredentials, requestGetDigioKycCredentials, requestSaveUserDeclaration,
  requestSaveUserSign,
  requestVerifyAadhaarEsign,
  requestVerifyDigioImageVerification, requestVerifyDigioKyc,
} from './digioFormRequests';
import {
  setAadhaarEsignCredentials,
  setAadhaarEsignVerificationStatus,
  setDigioFormError,
  setDigioFormStatus,
  setDigioImageVerificationStatus,
  setDigioImageVerifyCredentials,
  setDigioKycCredentials,
  setDigioKycVerificationStatus,
  setUserDeclarationStatus,
  setUserSignStatus,
} from './digioFormSlice';

export function* handleGetDigioImageVerifyCredentials(): Generator<any, any, any> {
  yield put(setDigioFormStatus('loading'));
  try {
    const response = yield call(
      requestGetDigioImageVerifyCredentials,
      {}
    );
    const { data } = response;

    if (data.status === 'success') {
      yield put(setDigioImageVerifyCredentials({
        identifier: data.identifier,
        requestId: data.requestId,
        token: data.token,
      }));
    }
  } catch (error: any) {
    yield put(setDigioFormError({
      isError: true,
      type: 'get_image_verify_credentials',
      message: error?.response?.data?.message,
    }));
  }
}

export function* handleVerifyDigioImageVerification(action:any): Generator<any, any, any> {
  yield put(setDigioFormStatus('loading'));
  try {
    const response = yield call(
      requestVerifyDigioImageVerification,
      action.payload
    );
    const { data } = response;

    if (data) {
      yield put(setDigioImageVerificationStatus(true));
      yield put(setUserDetails(data.user));
    }
  } catch (error: any) {
    // eslint-disable-next-line no-console
    console.log(error);
    yield put(setDigioFormError({
      isError: true,
      type: 'verify_image_verification',
      message: error?.response?.data?.message,
    }));
  }
}

export function* handleGetDigioKycCredentials(action:any): Generator<any, any, any> {
  yield put(setDigioFormStatus('loading'));
  try {
    const response = yield call(
      requestGetDigioKycCredentials,
      action.payload
    );
    const { data } = response;
    if (data.status === 'success') {
      yield put(setDigioKycCredentials({
        identifier: data.identifier,
        requestId: data.requestId,
        token: data.token,
      }));
    }
  } catch (error: any) {
    yield put(setDigioFormError({
      isError: true,
      type: 'get_kyc_credentials',
      message: error?.response?.data?.message,
    }));
  }
}

export function* handleVerifyDigioKyc(action:any): Generator<any, any, any> {
  yield put(setDigioFormStatus('loading'));
  try {
    const response = yield call(
      requestVerifyDigioKyc,
      action.payload
    );
    const { data } = response;
    if (data.message) {
      yield put(setDigioKycVerificationStatus(true));
      yield put(setUserDetails(data.user));
    }
  } catch (error: any) {
    yield put(setDigioFormError({
      isError: true,
      type: 'verify_kyc',
      message: error?.response?.data?.message,
    }));
  }
}

export function* handleGetAadhaarEsignCredentials(action:any): Generator<any, any, any> {
  yield put(setDigioFormStatus('loading'));
  try {
    const response = yield call(
      requestGetAadhaarEsignCredentials,
      action.payload
    );
    const { data } = response;
    if (data) {
      yield put(setAadhaarEsignCredentials(data));
    }
  } catch (error: any) {
    yield put(setDigioFormError({
      isError: true,
      type: 'get_esign_credentials',
      message: error?.response?.data?.message,
    }));
  }
}

export function* handleVerifyAadhaarEsign(action:any): Generator<any, any, any> {
  yield put(setDigioFormStatus('loading'));
  try {
    const response = yield call(
      requestVerifyAadhaarEsign,
      action.payload
    );
    const { data } = response;

    if (data.message) {
      yield put(setUserDetails(data.user));
      yield put(setAadhaarEsignVerificationStatus(true));
    }
  } catch (error: any) {
    yield put(setDigioFormError({
      isError: true,
      type: 'verify_esign',
      message: error?.response?.data?.message,
    }));
  }
}

export function* handleSaveUserDeclaration(action:any): Generator<any, any, any> {
  yield put(setDigioFormStatus('loading'));
  try {
    const response = yield call(
      requestSaveUserDeclaration,
      action.payload
    );
    const { data } = response;

    if (data.message) {
      yield put(setUserDeclarationStatus(true));
      yield put(setUserDetails(data.user));
    }
  } catch (error: any) {
    yield put(setDigioFormError({
      isError: true,
      type: 'save_user_declaration',
      message: error?.response?.data?.message,
    }));
  }
}

export function* handleSaveUserSign(action:any): Generator<any, any, any> {
  yield put(setDigioFormStatus('loading'));
  try {
    const response = yield call(
      requestSaveUserSign,
      { signature: action.payload.file }
    );
    const { data } = response;
    if (data.message) {
      yield put(setUserSignStatus(true));
    }
  } catch (error: any) {
    yield put(setDigioFormError({
      isError: true,
      type: 'save_user_sign',
      message: error?.response?.data?.message,
    }));
  }
}
